import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../../assets/new_left_slogan.png';
import _imports_1 from './images/liebiao@2x.png';
import _imports_2 from './images/weixin_icon_white.png';
import _imports_3 from './images/weixin_icon.png';
import _imports_4 from './images/image.png';
var _hoisted_1 = {
  class: "outer-container-header"
};
var _hoisted_2 = {
  class: "container-fluid long-container"
};
var _hoisted_3 = {
  class: "container"
};
var _hoisted_4 = {
  class: "navbar navbar-default long-header"
};
var _hoisted_5 = {
  class: "container-fluid long-nav"
};
var _hoisted_6 = {
  class: "navbar-header"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "log_img",
  src: _imports_0,
  alt: "logo"
}, null, -1);

var _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1);

var _hoisted_9 = [_hoisted_8];
var _hoisted_10 = {
  class: "nav navbar-nav navbar-right long-nav-font"
};
var _hoisted_11 = {
  class: "select_eng_box"
};

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "select_bottom_line"
}, null, -1);

var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "select_bottom_line"
}, null, -1);

var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "select_bottom_line"
}, null, -1);

var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "select_bottom_line"
}, null, -1);

var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "select_bottom_line"
}, null, -1);

var _hoisted_17 = {
  class: "long-language"
};

var _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "language_line"
}, "|", -1);

var _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "weixin_QR_code"
}, null, -1);

var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "weixin_QR_code_text"
}, "微信扫一扫", -1);

var _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "weixin_QR_code_text"
}, "关注我们", -1);

var _hoisted_22 = [_hoisted_19, _hoisted_20, _hoisted_21];
var _hoisted_23 = {
  class: "mobile-nav"
};

var _hoisted_24 = /*#__PURE__*/_createTextVNode("首页");

var _hoisted_25 = /*#__PURE__*/_createTextVNode("关于元羿 ");

var _hoisted_26 = /*#__PURE__*/_createTextVNode("管线科学");

var _hoisted_27 = /*#__PURE__*/_createTextVNode("生态伙伴");

var _hoisted_28 = /*#__PURE__*/_createTextVNode("媒体报道");

var _hoisted_29 = /*#__PURE__*/_createTextVNode("加入我们");

var _hoisted_30 = {
  class: "Global_collapse"
};
var _hoisted_31 = {
  class: "inside-nav"
};

var _hoisted_32 = /*#__PURE__*/_createTextVNode("CN");

var _hoisted_33 = /*#__PURE__*/_createTextVNode("EN");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("nav", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_Transition, {
    name: "logo",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__backInDown"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_router_link, {
        class: "navbar-brand logo",
        to: "/"
      }, {
        default: _withCtx(function () {
          return [_hoisted_7];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createElementVNode("div", {
    class: "navbar-toggle long-collapsed style_top_btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.changeMobileList && $setup.changeMobileList.apply($setup, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass({
      'bar-hover': $setup.showMobileList,
      'bar-unhover': !$setup.showMobileList
    })
  }, _hoisted_9, 2)])]), _createElementVNode("div", {
    class: _normalizeClass(['collapse', 'navbar-collapse', $setup.colorState === true ? 'white' : '']),
    id: "bs-example-navbar-collapse-1"
  }, [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.selectItem('/');
    })
  }, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass($setup.selectItemStr == '/' ? 'strong_text' : '')
      }, "首页", 2)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    onMousemove: _cache[2] || (_cache[2] = function ($event) {
      return $setup.hoverGlobal('aboutUs');
    }),
    onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
      return $setup.selectItem('/aboutUs');
    }, ["stop"])),
    "active-class": "long-liHover",
    to: "/aboutUs",
    class: "Global"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass($setup.selectItemStr == '/aboutUs' ? 'strong_text' : '')
      }, "关于元羿", 2)];
    }),
    _: 1
  }), _createElementVNode("div", {
    onMouseleave: _cache[10] || (_cache[10] = function () {
      return $setup.leaveGlobal && $setup.leaveGlobal.apply($setup, arguments);
    }),
    class: _normalizeClass(['select_eng', $setup.gloalflag ? 'select_eng_show' : ''])
  }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "select_item_btn",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $setup.jumpTo('aboutUs');
    })
  }, " 企业概况 "), _hoisted_12, _createElementVNode("div", {
    class: "select_item_btn",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $setup.jumpTo('advantage');
    })
  }, " 企业优势 "), _hoisted_13, _createElementVNode("div", {
    class: "select_item_btn",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $setup.jumpTo('teamList');
    })
  }, " 管理团队 "), _hoisted_14, _createElementVNode("div", {
    class: "select_item_btn",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return $setup.jumpTo('dongshi');
    })
  }, " 董事成员 "), _hoisted_15, _createElementVNode("div", {
    class: "select_item_btn",
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return $setup.jumpTo('invest');
    })
  }, " 投资方 "), _hoisted_16, _createElementVNode("div", {
    class: "select_item_btn",
    onClick: _cache[9] || (_cache[9] = function ($event) {
      return $setup.jumpTo('contactUs');
    })
  }, " 联系我们 ")])], 34)]), _createElementVNode("li", {
    onClick: _cache[11] || (_cache[11] = function ($event) {
      return $setup.selectItem('/pipeline');
    })
  }, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/pipeline"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass($setup.selectItemStr == '/pipeline' ? 'strong_text' : '')
      }, "管线科学", 2)];
    }),
    _: 1
  })]), _createElementVNode("li", {
    onClick: _cache[12] || (_cache[12] = function ($event) {
      return $setup.selectItem('/eco');
    })
  }, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/eco"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass($setup.selectItemStr == '/eco' ? 'strong_text' : '')
      }, "生态伙伴", 2)];
    }),
    _: 1
  })]), _createElementVNode("li", {
    onClick: _cache[13] || (_cache[13] = function ($event) {
      return $setup.selectItem('/report');
    })
  }, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/report"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass($setup.selectItemStr == '/report' ? 'strong_text' : '')
      }, "媒体报道", 2)];
    }),
    _: 1
  })]), _createElementVNode("li", {
    onClick: _cache[14] || (_cache[14] = function ($event) {
      return $setup.selectItem('/contact');
    })
  }, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/contact"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("span", {
        class: _normalizeClass($setup.selectItemStr == '/contact' ? 'strong_text' : '')
      }, "加入我们", 2)];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: ""
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", {
        class: _normalizeClass($setup.longFlag === 'cn' ? 'strong_text' : ''),
        onClick: _cache[15] || (_cache[15] = function ($event) {
          return $setup.changeLang('cn');
        })
      }, "中 ", 2), _hoisted_18, _createElementVNode("span", {
        class: _normalizeClass($setup.longFlag === 'en' ? 'strong_text' : ''),
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return $setup.changeLang('en');
        })
      }, " EN", 2), $setup.colorState ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_2,
        alt: "",
        class: "weixin_img",
        onMouseenter: _cache[17] || (_cache[17] = function ($event) {
          return $setup.showWeixin();
        })
      }, null, 32)) : _createCommentVNode("", true), !$setup.colorState ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _imports_3,
        alt: "",
        class: "weixin_img",
        onMouseenter: _cache[18] || (_cache[18] = function ($event) {
          return $setup.showWeixin();
        })
      }, null, 32)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
        class: "weixin_QR_code_box",
        onMouseleave: _cache[19] || (_cache[19] = function () {
          return $setup.leaveWeixin && $setup.leaveWeixin.apply($setup, arguments);
        })
      }, _hoisted_22, 544), [[_vShow, $setup.weixinFlag]])])];
    }),
    _: 1
  })])])], 2)])])])])]), _createVNode(_Transition, {
    name: "mobileNav"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", _hoisted_23, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_24];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/aboutUs",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_25];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/pipeline",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_26];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/eco",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_27];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/report",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_28];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/contact",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_29];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", _hoisted_30, [_createVNode(_component_el_collapse, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_collapse_item, {
            title: "Global"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("ul", _hoisted_31, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
                to: "/",
                class: _normalizeClass({
                  'mobile-nav-hover': $setup.showCompile
                }),
                onClick: _cache[20] || (_cache[20] = function ($event) {
                  return $setup.changeLang('cn');
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_32];
                }),
                _: 1
              }, 8, ["class"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
                to: "/",
                class: _normalizeClass({
                  'mobile-nav-hover': $setup.showCompile
                }),
                onClick: _cache[21] || (_cache[21] = function ($event) {
                  return $setup.changeLang('en');
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_33];
                }),
                _: 1
              }, 8, ["class"])])])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])], 512), [[_vShow, $setup.showMobileList]])];
    }),
    _: 1
  })], 64);
}